import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { RouteProps } from "react-router";
import { observer, inject } from "mobx-react";
import { get } from "lodash";
// Hooks and Utilities
import UserStore from "state/user";

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
interface IProps extends RouteProps {
	path: string;
	component: React.ElementType;
	props?: any;
	user?: UserStore;
	/**
	 * restricted = false meaning public route
	 * restricted = true meaning protected route
	 */
	restricted?: boolean;
}
const PublicRoute: React.FC<IProps> = ({
	component: Component,
	restricted,
	user,
	props: unauthenticatedRouteProps,
	...rest
}) => {
	return (
		<Route
			{...rest}
			render={props =>
				get(user, "isLoggedIn") && restricted ? (
					<Redirect to="/dashboard" />
				) : (
					<Component {...props} {...unauthenticatedRouteProps} />
				)
			}
		/>
	);
};

export default inject("user")(observer(PublicRoute));
